import React from 'react'

import './PushPreview.css'

const PushPreview = ({ state }) => (
  <div className="push">
    <div className="push__icon"></div>
    <div className="push__content">
      { state.title && <div className="push__title">{state.title}</div> } 
      <div className="push__message">{state.message}</div>
    </div>
  </div>
)

export default PushPreview


// WEBPACK FOOTER //
// ./src/components/campaigns/previews/PushPreview.js